import { CheckIcon } from '@chakra-ui/icons';
import {
  chakra,
  Button,
  Heading,
  Text,
  VStack,
  Box,
} from '@chakra-ui/react';
import React from 'react';
import PriceLabel from './form/PriceLabel';

type RadioButtonParams = {
  iconPosition?: 'left' | 'right',
  price?: number,
  unit?: string,
  isActive?: boolean,
  children?: React.ReactNode,
  onClick?: () => void,
};

const RadioButton = ({
  iconPosition, price, unit, isActive, children, ...rest
}: RadioButtonParams) => {
  let leftIcon;
  let rightIcon;
  const icon = <Box opacity={isActive ? 100 : 0}><CheckIcon /></Box>;
  if (iconPosition === 'right') {
    rightIcon = icon;
  } else {
    leftIcon = icon;
  }
  return (
    <Button
      bg="white"
      borderColor="gray.200"
      borderWidth="1px"
      isActive={isActive}
      _active={{
        bg: 'blue.50',
        borderColor: 'blue.500',
      }}
      _hover={{
        borderColor: 'blue.500',
      }}
      w={{ base: '100%', md: 'auto' }}
      height="auto"
      p="1em"
      leftIcon={leftIcon}
      rightIcon={rightIcon}
      {...rest}
    >
      <VStack pr="1em" w="100%" align="flex-start">
        <Heading fontSize="md">{children}</Heading>
        <PriceLabel price={price} unit={unit} />
      </VStack>
    </Button>
  );
};

export { RadioButton };
